<template>
<div class="chapter">
<div class="inner_page">
<p class="crt" id="d12e61"><b>ZONDERVAN</b></p>
<p class="crt" id="d12e66"><i>I SAW HIM IN YOUR EYES</i><br/>Copyright © 2006 by Andrew Collins</p>
<p class="crt" id="d12e71">All rights reserved under International and Pan-American Copyright Conventions. By payment of the required fees, you have been granted the non-exclusive, non-transferable right to access and read the text of this e-book on-screen. No part of this text may be reproduced, transmitted, down-loaded, decompiled, reverse engineered, or stored in or introduced into any information storage and retrieval system, in any form or by any means, whether electronic or mechanical, now known or hereinafter invented, without the express written permission of Zondervan.</p>
<p class="crt" id="d12e73">ePub Edition June 2009 ISBN: 0-310-86255-8</p>
<p class="crt" id="d12e75">Requests for information should be addressed to:</p>
<p class="crt" id="d12e77">Zondervan, <i>Grand Rapids, Michigan 49530</i></p>
<hr/><p class="crt" id="d12e82"><b>Library of Congress Cataloging-in-Publication Data </b></p>
<p class="crt" id="d12e85">Collins, Ace<br/>     I saw Him in your eyes: everyday people making extraordinary impact in the lives of Karen Kingsbury, Terri Blackstock, Bobby Bowden, Charlie Daniels, S. Truett Cathy, and more / Ace Collins.<br/>       p. cm.<br/>     Includes bibliographical references.<br/>    ISBN-13: 978-0-310-226318-0<br/>     1. Christian biography—United States. 2. Celebrities—Religious life—United States. I. Title.<br/>   BR1700.3.C65 2006<br/>   277.3'082'.0922 — dc22 <br/>  {B}</p>
<p class="crtr" id="d12e106">2005019453</p>
<hr/><p class="crt" id="d12e110">All Scripture quotations, unless otherwise indicated, are taken from the <i>Holy Bible: New International Version</i><sup>®</sup>. NIV<sup>®</sup>. Copyright © 1973, 1978, 1984 by International Bible Society. Used by permission of Zondervan. All rights reserved.</p>
<p class="crt" id="d12e120">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means — electronic, mechanical, photocopy, recording, or any other — except for brief quotations in printed reviews, without the prior permission of the publisher.</p>
<hr/><p class="crt" id="d12e123">06 07 08 09 10 11 • 16 15 14 13 12 11 10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Coll_ISBN0310862558_epub_c4_r1.vue?359f6977